import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-email-suggest-overlay',
  templateUrl: './email-suggest-overlay.component.html',
  styleUrls: ['./email-suggest-overlay.component.scss'],
})
export class EmailSuggestOverlayComponent {
  @Input() suggestions: string[] = [];
  @Input() activeIndex = -1;
  @Output() selectItem = new EventEmitter<string>();
  @Output() deleteItem = new EventEmitter<string>();

  onSelect(event: MouseEvent, item: string): void {
    // Prevent blur before selection completes
    event.preventDefault();
    this.selectItem.emit(item);
  }

  onDelete(event: MouseEvent, item: string): void {
    event.preventDefault();
    event.stopPropagation();
    this.deleteItem.emit(item);
  }
}
